var _module_exports = "<div class=\"status-badge-wrapper\">\n  <i class=\"icon mr-4\" ng-class=\"$ctrl.icon\" ng-if=\"::$ctrl.icon\"></i>\n  <ng-transclude></ng-transclude>\n</div>";;
var path = '/workspace/src/app/common/ui/status-badge/status-badge.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;